import axios from "axios";
import { getApiUrl } from "../../../config";

export function requestGetCalendarStatus() {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/calendar/status`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetMeetings(query = {}) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/calendar/meetings`,
        params: query,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetManagerReport(query = {}) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/calendar/manager-report`,
        params: query,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetManagerReportDrilldown(query = {}) {
    return axios.request({
        method: "get",
        url: `${getApiUrl()}/calendar/manager-report/drilldown`,
        params: query,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestScheduleMeeting(body) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/calendar/events`,
        data: body,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetMeetingSlots(body) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/calendar/availability`,
        data: body,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestRecordMeetingTime(meetingId, body) {
    return axios.request({
        method: "post",
        url: `${getApiUrl()}/calendar/meetings/${meetingId}/time`,
        data: body,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetMeetingManualTrack(meetingId, body) {
    return axios.request({
        method: "patch",
        url: `${getApiUrl()}/calendar/meetings/${meetingId}/manual-track`,
        data: body,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestSetUserCalendarOptOut(userId, body) {
    return axios.request({
        method: "patch",
        url: `${getApiUrl()}/user/${userId}/calendar-opt-out`,
        data: body,
        withCredentials: true,
        crossorigin: true,
    });
}
